import { Environment } from '../../config/environment';
import { IBundlePriceResponse3, IVodPriceResponse3 } from '../models/AndromeTV.types';
import { Backend } from '../Backend';
import { VodPriceFilter } from './PriceApi.types';

export class PriceApi {
  /**
   * Request a price for all resolutions in a bundle
   */
  static forBundle(backend: Backend, bundleId: string, entitlementId: string): Promise<IBundlePriceResponse3> {
    const param = {
      entitlementId: entitlementId,
      type: Environment.system,
    };
    const url = backend.makeUrl(`price/v4/bundle/${encodeURIComponent(bundleId)}`, param);
    return backend.getJson(url, backend.bearer) as Promise<IBundlePriceResponse3>;
  }

  /**
   * Request a price and type for each asset in a VOD
   */
  static forVod(backend: Backend, vodId: string, filter: VodPriceFilter): Promise<IVodPriceResponse3> {
    const param = { ...filter, type: Environment.system };
    const url = backend.makeUrl(`price/v4/vod/${encodeURIComponent(vodId)}`, param);
    return backend.getJson(url, backend.bearer) as Promise<IVodPriceResponse3>;
  }
}
